<nb-card>
  <nb-card-header class="p-0">
    <span class="title">{{ title }}</span>
  </nb-card-header>
  <nb-card-body class="p-0 pb-3">
    <p>
      <br/>
      <span [innerHTML]="content"></span>
    </p>
    @if (option) {
      <div class="checkbox-div">
        <nb-checkbox (checkedChange)="checkedChange()">
          {{ option }}
        </nb-checkbox>
      </div>
    }
  </nb-card-body>
  <nb-card-footer class="text-right">
    @if (canCancel) {
      <button nbButton (click)="close()" class="cancel">
        {{ 'theme.status-change-dialog.discard' | translate }}
      </button>
    }
    <button nbButton (click)="close(true)" class="ms-3">
      {{ 'theme.status-change-dialog.ok' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
